import { cn } from "@/utils/cn";
import { BackIcon } from "../back-icon";

interface ForwardIconProps {
  className?: string;
}

export const ForwardIcon = ({ className }: ForwardIconProps) => {
  return <BackIcon className={cn("rotate-180", className)} />;
};
